function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import ViewManager from './ViewManager';
import page from 'page';

var RouterManager = /*#__PURE__*/function () {
  function RouterManager(c, api) {
    var _this = this;

    _classCallCheck(this, RouterManager);

    this.api = api;
    this.root = c.urls.root;
    this.routes = {};
    this.prev = null;
    this.cur = null;
    this.historyCount = 0;
    this.initialized = false;
    this.viewManager = new ViewManager(c);
    page.exit('*', function (ctx, next) {
      // console.log('Exit '+ctx.cur)
      ctx.prev = ctx.cur;
      _this.prev = _this.cur;
      next();
    });
  }

  _createClass(RouterManager, [{
    key: "redirect",
    value: function redirect(location) {
      if (!location) {
        throw new Error("\"location\" no esta definido");
      }

      this.historyCount = this.historyCount++;
      page.redirect(location);
    }
  }, {
    key: "back",
    value: function back() {
      if (!location) {
        throw new Error("\"location\" no esta definido");
      }

      this.historyCount = this.historyCount--;
      page.back();
    }
  }, {
    key: "_get_opts",
    value: function _get_opts(opts, ctx) {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (opts) {
          opts(ctx, _this2.api).then(function (options, api) {
            resolve(options, _this2.api);
          }).catch(function () {
            resolve({});
          });
        } else {
          resolve({});
        }
      });
    }
  }, {
    key: "route",
    value: function route(opts) {
      var _this3 = this;

      page(opts.path, function (ctx, next) {
        ctx.cur = opts.name; // console.log('Enter '+ctx.cur)

        _this3.cur = opts;

        if (_this3.prev && _this3.cur) {
          if (_this3.prev.name !== _this3.cur.name) {
            if (_this3.prev.name) {
              // console.log(`unmounting ${this.prev.name}`)
              _this3.viewManager.unmount(_this3.prev.name);
            }
          }
        }

        var canMount = opts.name ? !!opts.template : false;

        _this3._get_opts(opts.props, ctx).then(function (props) {
          new Promise(function (resolve, reject) {
            if (canMount) {
              /**
               * container
               * name
               * template
               * props
               */
              _this3.viewManager.mount(opts.name, opts.template, props).then(function (mounted) {
                resolve(mounted);
              }).catch(function (err) {
                reject(err);
              });
            } else {
              resolve(null);
            }
          }).then(function (mounted) {
            if (opts.enter) {
              try {
                opts.enter(ctx, next, mounted, _this3.api);
              } catch (err) {
                if (opts.error) {
                  opts.error(ctx, next, err);
                }
              }
            }
          }).catch(function (err) {
            if (opts.error) {
              opts.error(ctx, next, err);
            }
          });
        });
      });
      this.routes[opts.name] = opts;
    }
  }, {
    key: "init",
    value: function init() {
      if (!this.initialized) {
        this.initialized = true;
        page({
          hashbang: true
        });
      }
    }
  }], [{
    key: "go",
    value: function go(location) {
      if (!location) {
        throw new Error("\"location\" no esta definido");
      }

      this.historyCount = this.historyCount++;
      page(location);
    }
  }]);

  return RouterManager;
}();

export { RouterManager as default };